import { REQUEST_RESULT_STRUCTURE } from 'constants/api';

export class DocumentFieldTypeApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async editDocumentFieldType(body) {
    return this.#http.put(`api/document-field-types/${body.id}`, body);
  }

  async deleteDocumentFieldType({ id }) {
    return this.#http.delete(`api/document-field-types/${id}`);
  }
  async getDocumentFieldTypes() {
    return this.#http.get('/api/document-field-types', {
      params: {
        resultStructure: REQUEST_RESULT_STRUCTURE.FLAT_VALUES,
      },
    });
  }

  async createDocumentFieldType(body) {
    return this.#http.post('/api/document-field-types', body);
  }
}
